import {ApplicationConfig, provideBrowserGlobalErrorListeners, LOCALE_ID} from '@angular/core';
import {provideHttpClient} from '@angular/common/http';
import {provideRouter} from '@angular/router';
import {provideNativeDateAdapter, MAT_DATE_LOCALE, MatDateFormats, MAT_DATE_FORMATS} from '@angular/material/core';
import {TitleStrategy} from '@angular/router';
import {AppTitleStrategy} from './core/app-title.strategy';

import {routes} from './app.routes';

const GB_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideNativeDateAdapter(),
    {provide: LOCALE_ID, useValue: 'en-GB'},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {provide: MAT_DATE_FORMATS, useValue: GB_DATE_FORMATS},
    {provide: TitleStrategy, useClass: AppTitleStrategy},
  ],
};
